document.addEventListener("DOMContentLoaded", function() {

    // porovnani
    //==========
    (function () {
        let id, bottom, active;

        function probliknoutNastaveni()
        {
            let pocetProbliknuti = 1;
            const blikani = function () {
                document.querySelector('.porovnani-head').classList.toggle('add-porovnani');
            };
            for (let i = 0; i < (pocetProbliknuti * 2); i++) {
                setTimeout(blikani, (600 * i));
            }
        }

        function addToPorovnani(porovnani)
        {
            id = porovnani.id.replace('p-','');
            if(porovnani.classList.contains('active')){
                active = false;
                porovnani.classList.remove('active');
                if (porovnani.innerHtml !== '')
                    porovnani.innerHtml = (locale.locale === 'cs' ? "<span>Porovnat</span>" : '<span>Compare</span>');
            } else {
                console.log('pridani');
                active = true;
                porovnani.classList.add('active');
                if (porovnani.innerHtml !== '')
                    porovnani.innerHtml = (locale.locale === 'cs' ? "<span>Odebrat</span>" : '<span>Remove</span>');
            }

            let request = new XMLHttpRequest();
            request.open('GET', locale.url_parovani +'?id=' + id + '&ajax=1&=' + new Date().getTime(), true);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    let link = document.querySelector('.js-porovnani-link');
                    if(typeof(link) === 'undefined' || link === null){
                        window.location.reload();
                    } else {
                        let data = this.response;
                        bottom = document.querySelector('.JS-porovnani-bottom');
                        link.querySelector('.count').textContent = data;
                        link.style.display = 'block';
                        bottom.innerHtml = data;
                        bottom.style.display = 'block';
                    }
                    probliknoutNastaveni();
                }
            };
            request.send();
        }

        let porovnaniButton = document.querySelectorAll('.js-porovnani');
        if(typeof(porovnaniButton) != 'undefined' && porovnaniButton != null) {
            porovnaniButton.forEach(function(el) {
                el.addEventListener('click', function () {
                    addToPorovnani(this);
                });
            });
        }

        // Navigace
        let navigace, next, prev, hide, activeItem;
        navigace = document.querySelector('.navigace');
        if(typeof(navigace) === 'undefined' || navigace === null)
            return;

        next = navigace.querySelector('.next');
        prev = navigace.querySelector('.prev');

        next.addEventListener('click', function() {
            prev.style.display = 'block';
            document.querySelectorAll('tr').forEach(function (el) {
                activeItem = el.querySelector('td.active');
                hide = el.querySelector('td.active:last-child').nextElementSibling;

                activeItem.classList.remove('active');
                activeItem.classList.add('hide');

                hide.classList.remove('hide');
                hide.classList.add('active');

                hide = el.querySelector('td.active:last-child').nextElementSibling;
                if((typeof(activeItem) !== 'undefined' && activeItem !== null) && (typeof(hide) === 'undefined' || hide === null))
                    next.style.display = 'none';
            });
        });

        prev.addEventListener('click', function () {
            next.style.display = 'block';
            document.querySelectorAll('tr').forEach(function (el) {
                activeItem = el.querySelector('td.active:last-child');
                hide = el.querySelector('td.active:first-child').previousElementSibling;

                activeItem.classList.remove('active');
                activeItem.classList.add('hide');

                hide.classList.remove('hide');
                hide.classList.add('active');

                hide = el.querySelector('td.active:first-child').previousElementSibling;
                if((typeof(activeItem) !== 'undefined' && activeItem !== null) && (typeof(hide) === 'undefined' || hide === null))
                    prev.style.display = 'none';
            });
        });
    }());
});